
import React, {  useMemo }from 'react';
import styled from 'styled-components';
import * as lo from 'lodash/fp';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { DataGrid } from '@process-advisor/process-miner/modals/detail/dataGrid';
import { taskDetailGridColumns } from '@process-advisor/process-miner/modals/detail/taskDetail/taskDetailGridColumns';

type Row = {};
let columns = []
const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const TaskDetailGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);

    React.useEffect(() => {
        const listener = () => {
            apiProvider.setTaskDetailExtract({type: 'detail'})
            setData(apiProvider.processDetailTaskSummary());
        }
        listener();

        apiProvider.on(Event.openTaskDetailModal, listener);

        return () => {
            apiProvider.off(Event.openTaskDetailModal, listener);
        };
    }, []);

    const statusBar = useMemo(() => {
        return {
          statusPanels: [
            { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
            { statusPanel: 'agTotalRowCountComponent', align: 'center' },
          ],
        };
      }, []);


    const rows = data.map((row, id) => ({ id, ...row }));
    if (lo.isEmpty(columns)) {
        columns = taskDetailGridColumns(rows);
    }
    return (
        <Wrapper>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'task-detail'}
                height="550px" />
        </Wrapper>
    );
};

